.input {
  height: 40px;
  padding: 0 16px;
  width: 100%;
  border-radius: 4px;
  border: 1px solid #c1b9b9;
  background-color: #ffffff;
  font-size: 14px;
  line-height: 1.5;
  color: #333;
  outline: none;
  transition: border-color 0.2s ease;
}

.input:focus {
  border-color: #007bff;
}

.input:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

/* Label Styles */
.label {
  font-size: 14px;
  color: #333;
}

.required {
  color: red;
  font-size: 12px;
  margin-left: 4px;
}

/* Input Error Styles */
.error {
  font-size: 12px;
  color: red;
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 4px;
}
